import { normalizeAuthError } from '@/services/auth/normalizeAuthError'

export function isAbortLikeError(error: unknown): boolean {
  if (!(error instanceof Error)) return false

  return (
    error.name === 'CanceledError' ||
    error.name === 'AbortError' ||
    /aborted|cancell?ed/i.test(error.message)
  )
}

export function isAuthHardFailure(error: unknown): boolean {
  const { name, type, code, message } = normalizeAuthError(error)
  const normalizedName = name ?? type ?? code

  if (
    typeof normalizedName === 'string' &&
    normalizedName.startsWith('NotAuthorizedException')
  ) {
    return true
  }

  if (
    typeof message === 'string' &&
    /Access to Identity .* is forbidden/i.test(message)
  ) {
    return true
  }

  return false
}

/** Definitive token failures used by Amplify's Cognito token orchestrator. */
export function isTokenRefreshAuthFailure(error: unknown): boolean {
  const { name, type, code } = normalizeAuthError(error)
  const errorName = name ?? type ?? code
  if (!errorName) return false

  return [
    'NotAuthorizedException',
    'TokenRevokedException',
    'UserNotFoundException',
    'PasswordResetRequiredException',
    'UserNotConfirmedException',
    'RefreshTokenReuseException',
  ].some((authErrorName) => errorName.startsWith(authErrorName))
}
